import axios from "axios";

export const STREAMING_LOAD_TEST_API_PATH = "/api/event/plataformaEventos/schedule-streaming/test";

export function getStreamingLoadTestStatus({ jobId, eventId, scheduleId, streamingId }) {
    return axios.get(
        STREAMING_LOAD_TEST_API_PATH + '/' + encodeURIComponent(jobId),
        {
            params: {
                event_id: Number(eventId),
                schedule_id: Number(scheduleId),
                streaming_id: Number(streamingId),
            },
        },
    );
}

const testIdentityParams = ({ eventId, scheduleId, streamingId }) => ({
    event_id: Number(eventId),
    schedule_id: Number(scheduleId),
    streaming_id: Number(streamingId),
});

export function cancelStreamingLoadTest({ jobId, eventId, scheduleId, streamingId }) {
    return axios.post(
        STREAMING_LOAD_TEST_API_PATH + '/' + encodeURIComponent(jobId) + '/cancel',
        testIdentityParams({ eventId, scheduleId, streamingId }),
    );
}

export function getStreamingLoadTestReport({ jobId, eventId, scheduleId, streamingId }) {
    return axios.get(
        STREAMING_LOAD_TEST_API_PATH + '/' + encodeURIComponent(jobId) + '/report',
        { params: testIdentityParams({ eventId, scheduleId, streamingId }) },
    );
}

export const buildStreamingLoadTestStartPayload = ({
    eventId,
    scheduleId,
    streamingId,
    connectionCount,
    runDurationSeconds,
    randomSeed,
    scenario,
    streamCohortsPreset,
}) => ({
    event_id: Number(eventId),
    schedule_id: Number(scheduleId),
    streaming_id: Number(streamingId),
    connection_count: Number(connectionCount),
    run_duration_seconds: Number(runDurationSeconds),
    random_seed: String(randomSeed || "").trim(),
    ...(scenario ? { scenario: String(scenario).trim() } : {}),
    ...(streamCohortsPreset ? { stream_cohorts_preset: String(streamCohortsPreset).trim() } : {}),
});

export const streamingLoadTestComparisonStatus = (comparison) => (
    comparison?.passed === true ? "matched" : comparison?.passed === false ? "mismatch" : "unavailable"
);

export function startStreamingLoadTest(input) {
    return axios.post(STREAMING_LOAD_TEST_API_PATH, {
        ...buildStreamingLoadTestStartPayload(input),
    });
}
